import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComicsSection from './components/HotComicsSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'http://homekleans.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${'http://homekleans.com'}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'http://homekleans.com',
    logo: `${'http://homekleans.com'}/logo.png`,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京市朝阳区',
      addressCountry: 'CN',
    },
    sameAs: ['http://homekleans.com/'],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - 无删减漫画免费阅读`,
    description: siteInfo.description,
    url: 'http://homekleans.com/',
    publisher: {
      '@type': 'Organization',
      name: siteInfo.name,
    },
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(orgSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webpageSchema)}
      </script>
      <Navbar />
      <main>
        <HeroSection />
        <HotComicsSection />
        <LatestUpdatesSection />
        <StatsSection />
        <CategorySection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}